<button
  mat-raised-button
  class="text-uppercase"
  [ngClass]="classes"
  [color]="color"
  (click)="onClick()"
  [disabled]="disabled"
>
  <ng-container *ngIf="iconLocation === 'left' && icon">
    <fa-icon [icon]="icon" class="mr-2"></fa-icon>
  </ng-container>
  {{ dataTxt | translated }}
  <ng-container *ngIf="iconLocation === 'right' && icon">
    <fa-icon [icon]="icon" class="ml-2"></fa-icon>
  </ng-container>
</button>
